import axios from "axios";

export default {
  data() {
    return {
      load_complete: false,
      leaderSelected: null,
      project: {
        title: { gl: "", es: "", en:"" },
        description: { gl: "", es: "", en:"" },
        objectives: { gl: "", es: "", en:"" },
        results: { gl: "", es: "", en:"" },
        acronym: null,
        doi: null,
        code: null,
        type: "",
        external: false,
        main_citius_investigators: [],
        citius_investigators: [],
        main_external_investigators: [""],
        external_investigators: [""],
        funder_programs: [],
        funder_text: {gl: "", es: "", en:"" },
        total_budget: null,
        citius_budget: null,
        contractor: null,
        additional_text: "",
        image: null,
        image_squared: null,
        start_date: "",
        end_date: "",
        consortium: {
          is_citius: "",
          leader: "",
          partners: []
        },
        uri: "",
        video_id: "",
        research_areas: [],
        subprojects: []
      },

      consortium: {
        is_citius: "",
        leader: "",
        partners: []
      },

      subproject: {
        title: { gl: "", es: "", en:"" },
        description: { gl: "", es: "", en:"" },
        main_citius_investigators: [],
        citius_investigators: [],
        main_external_investigators: [""],
        external_investigators: [""],
        start_date: "",
        end_date: "",
        contractor: null
      },
      tabs_subprojects: [],
      has_consortium: false,
    };
  },

  methods: {
    getProject(path) {
      axios
          .get(path)
          .then(response => {
            this.project = response.data;
            this.project.subprojects.forEach(subproject => {
              this.tabs_subprojects.push({
                tab_title: 0,
                tab_description: 0,
                menu_start_date: false,
                menu_end_date: false
              });
            });
          })
          .finally(() => this.load_complete = true)
          .catch(error => {
            console.log(error);
          });
    },
    getProjectToUpdate(path) {
      axios
          .get(path)
          .then(response => {
            this.project = response.data;
            this.addEmptyDataMultiLanguage()
            if(this.project.consortium !== null){
              this.has_consortium = true
              this.project.consortium.leader = response.data.consortium.leader;
              this.leaderSelected = response.data.consortium.leader;
              this.project.consortium.partners = response.data.consortium.partners;
            } else {
              this.project.consortium = this.consortium
            }
            this.project.subprojects.forEach(subproject => {
              this.tabs_subprojects.push({
                tab_title: 0,
                tab_description: 0,
                menu_start_date: false,
                menu_end_date: false
              });
            });
          })
          .finally(() => this.load_complete = true)
          .catch(error => {
            console.log(error);
          });
    },
    getProjectWithBreadCrumb(path) {
      axios
        .get(path)
        .then(response => {
          this.project = response.data;
          this.project.subprojects.forEach(subproject => {
            this.tabs_subprojects.push({
              tab_title: 0,
              tab_description: 0,
              menu_start_date: false,
              menu_end_date: false
            });
          });
        })
        .finally(() => this.setBreadcrumb())
        .catch(error => {
          console.log(error);
        });
    },

    setBreadcrumb() {
      let text;
      if (
        this.project.title["gl"] !== "" &&
        this.project.title["gl"] !== undefined
      ) {
        text = this.project.title["gl"];
      } else if (
        this.project.title["es"] !== "" &&
        this.project.title["es"] !== undefined
      ) {
        text = this.project.title["es"];
      } else {
        text = this.project.title["en"];
      }

      let item = {
        text: text,
        disabled: true,
        last: true
      };
      if (
        !this.$route.meta.breadCrumb.some(breadcrumb => {
          return breadcrumb.last === true;
        })
      ) {
        this.$route.meta.breadCrumb.push(item);
      } else {
        this.$route.meta.breadCrumb.pop();
        this.$route.meta.breadCrumb.push(item);
      }
      this.$store.state.sectionTitle = text;
    },

    loadDefaultMainInvestigator() {
      const path =
        this.$store.state.endpoint +
        "/person/" +
        this.$store.getters.user.person;
      axios
        .get(path)
        .then(response => {
          this.project.main_citius_investigators.push({
            id: response.data.id,
            name:
              response.data.preferred_name.given_name +
              " " +
              response.data.preferred_name.family_name
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    addEmptyDataMultiLanguage(){
      let fields = ["title", "description", "objectives", "results", "funder_text"]
      let subproject_fields = ["title", "description"]
      let keys = ['gl', 'es', 'en']
      fields.forEach(field => {
        // Older drafts did not capture funding text; omit it until explicitly edited.
        if (field === 'funder_text' && this.project[field] === undefined) return;
        if (!this.project[field] || typeof this.project[field] !== 'object') this.$set(this.project, field, {});
        keys.forEach(key => {
          if(this.project[field][key] === undefined){
            this.$set(this.project[field], key, "")
          }
        })
      })
      this.project.subprojects.forEach(subproject => {
        subproject_fields.forEach(field => {
          if (!subproject[field] || typeof subproject[field] !== 'object') this.$set(subproject, field, {});
          keys.forEach(key => {
            if(subproject[field][key] === undefined){
              this.$set(subproject[field], key, "")
            }
          })
        })
      })

    }
  }
};
